import React, { Suspense } from 'react'; // ❗️ Импорт Suspense
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { BrandingProvider } from './BrandingContext';
import { ThemeProvider } from './ThemeContext'; 
import './i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<div className="loading-full">Загрузка...</div>}>
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <BrandingProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </BrandingProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  </Suspense>
);